import PropTypes from 'prop-types';
import './quickFacts.scss';

const QuickFacts = ({ facts, labels }) => {
  return (
    <div className="gw-hotel-info-overview__quick-facts-container">
      <h3 className="gw-hotel-info-overview__quick-facts-heading">
        {labels.factsHeader}
      </h3>
      <ul className="gw-hotel-info-overview__quick-facts">
        {facts.map((fact) => {
          return (
            <li key={fact.title}>
              <div className="gw-hotel-info-overview__quick-fact">
                <span className="gw-hotel-info-overview__quick-fact-title">
                  {fact.title}
                </span>
                <span className="gw-hotel-info-overview__quick-fact-value">
                  {fact.shortDisplayValue}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

QuickFacts.propTypes = {
  facts: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      shortDisplayValue: PropTypes.string,
    }),
  ).isRequired,
  labels: PropTypes.shape({ factsHeader: PropTypes.string }).isRequired,
};

export default QuickFacts;
